import {
  Store,
  Product,
  Order,
  Gift,
  SpecialDate,
  UserProfile,
  Plan,
} from '../types'

export const STORES: Store[] = [
  {
    id: '1',
    name: 'Chai Point',
    image:
      'https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=800&q=80',
    distance: '0.2 km',
    rating: 4.8,
    tags: ['Coffee', 'Chai', 'Snacks'],
    hours: '7:00 AM - 10:00 PM',
    phone: '+91 98765 43210',
    storeId: 'CP-8821',
    description:
      'Popular chai chain with authentic Indian tea and quick bites.',
    address: '123 MG Road, Bangalore',
  },
  {
    id: '2',
    name: 'The Bowl Company',
    image:
      'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=800&q=80',
    distance: '0.5 km',
    rating: 4.6,
    tags: ['Food', 'Healthy', 'Bowls'],
    hours: '11:00 AM - 11:00 PM',
    phone: '+91 98765 43211',
    storeId: 'TBC-4421',
    description:
      'Fresh, healthy rice and noodle bowls with Indian and Asian flavors.',
    address: '456 Indiranagar, Bangalore',
  },
  {
    id: '3',
    name: 'Blossoms Book House',
    image:
      'https://images.unsplash.com/photo-1495446815901-a7297e633e8d?auto=format&fit=crop&w=800&q=80',
    distance: '0.8 km',
    rating: 4.9,
    tags: ['Books', 'Quiet', 'Reading'],
    hours: '10:00 AM - 8:00 PM',
    phone: '+91 98765 43212',
    storeId: 'BBH-1129',
    description:
      'Iconic Bangalore bookstore with vast collection and cozy reading corners.',
    address: '789 Church Street, Bangalore',
  },
  {
    id: '4',
    name: 'Toit Brewpub',
    image:
      'https://images.unsplash.com/photo-1511882150382-421056c89033?auto=format&fit=crop&w=800&q=80',
    distance: '1.2 km',
    rating: 4.7,
    tags: ['Brewery', 'Food', 'Nightlife'],
    hours: '12:00 PM - 11:30 PM',
    phone: '+91 98765 43213',
    storeId: 'TOIT-9988',
    description:
      "Bangalore's favorite microbrewery with craft beers and continental food.",
    address: '321 Indiranagar, Bangalore',
  },
  {
    id: '5',
    name: 'Pizza Bakery',
    image:
      'https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&w=800&q=80',
    distance: '1.5 km',
    rating: 4.5,
    tags: ['Pizza', 'Italian', 'Casual'],
    hours: '11:00 AM - 11:00 PM',
    phone: '+91 98765 43214',
    storeId: 'PB-5544',
    description:
      'Authentic wood-fired pizzas with fresh toppings and cozy ambiance.',
    address: '555 Koramangala, Bangalore',
  },
  {
    id: '6',
    name: 'MTR',
    image:
      'https://images.unsplash.com/photo-1589301760014-d929f3979dbc?auto=format&fit=crop&w=800&q=80',
    distance: '0.4 km',
    rating: 4.9,
    tags: ['Food', 'South Indian', 'Traditional'],
    hours: '6:30 AM - 11:00 AM, 12:30 PM - 3:30 PM, 7:00 PM - 9:30 PM',
    phone: '+91 98765 43215',
    storeId: 'MTR-1924',
    description:
      'Legendary Bangalore institution serving authentic South Indian breakfast and meals since 1924.',
    address: '14 Lalbagh Road, Bangalore',
  },
  {
    id: '7',
    name: 'Third Wave Coffee',
    image:
      'https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?auto=format&fit=crop&w=800&q=80',
    distance: '0.6 km',
    rating: 4.7,
    tags: ['Coffee', 'Cafe', 'Specialty'],
    hours: '8:00 AM - 11:00 PM',
    phone: '+91 98765 43216',
    storeId: 'TWC-3344',
    description:
      'Specialty coffee roasters with artisanal brews and cozy workspace vibes.',
    address: '100 Feet Road, Indiranagar, Bangalore',
  },
  {
    id: '8',
    name: 'Corner House Ice Cream',
    image:
      'https://images.unsplash.com/photo-1563805042-7684c019e1cb?auto=format&fit=crop&w=800&q=80',
    distance: '0.9 km',
    rating: 4.8,
    tags: ['Dessert', 'Ice Cream', 'Family'],
    hours: '11:00 AM - 11:00 PM',
    phone: '+91 98765 43217',
    storeId: 'CH-1950',
    description:
      'Iconic Bangalore ice cream parlor famous for Death by Chocolate sundae.',
    address: '17th Cross, Malleshwaram, Bangalore',
  },
  {
    id: '9',
    name: 'Veena Stores',
    image:
      'https://images.unsplash.com/photo-1630383249896-424e482df921?auto=format&fit=crop&w=800&q=80',
    distance: '1.1 km',
    rating: 4.6,
    tags: ['Food', 'South Indian', 'Breakfast'],
    hours: '7:00 AM - 11:00 AM, 4:00 PM - 8:00 PM',
    phone: '+91 98765 43218',
    storeId: 'VS-1977',
    description:
      'Famous for crispy masala dosas and filter coffee in traditional Bangalore style.',
    address: 'Gandhi Bazaar, Basavanagudi, Bangalore',
  },
  {
    id: '10',
    name: 'Truffles',
    image:
      'https://images.unsplash.com/photo-1550547660-d9450f859349?auto=format&fit=crop&w=800&q=80',
    distance: '0.7 km',
    rating: 4.5,
    tags: ['Food', 'Burgers', 'American'],
    hours: '12:00 PM - 11:30 PM',
    phone: '+91 98765 43219',
    storeId: 'TRF-5566',
    description:
      'Legendary burger joint with massive portions and indulgent comfort food.',
    address: '80 Feet Road, Koramangala, Bangalore',
  },
  {
    id: '11',
    name: 'Naturals Ice Cream',
    image:
      'https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?auto=format&fit=crop&w=800&q=80',
    distance: '0.5 km',
    rating: 4.7,
    tags: ['Dessert', 'Ice Cream', 'Natural'],
    hours: '11:00 AM - 11:00 PM',
    phone: '+91 98765 43220',
    storeId: 'NAT-8899',
    description:
      'Fresh fruit ice creams made with real fruits and no artificial flavors.',
    address: 'Jayanagar 4th Block, Bangalore',
  },
  {
    id: '12',
    name: "Brahmin's Coffee Bar",
    image:
      'https://images.unsplash.com/photo-1511920170033-f8396924c348?auto=format&fit=crop&w=800&q=80',
    distance: '1.3 km',
    rating: 4.8,
    tags: ['Coffee', 'Traditional', 'Quick Bites'],
    hours: '6:30 AM - 1:00 PM, 3:30 PM - 8:30 PM',
    phone: '+91 98765 43221',
    storeId: 'BCB-1965',
    description:
      'Old-school Bangalore cafe serving strong filter coffee and crispy vadas.',
    address: 'Shankarapuram, Basavanagudi, Bangalore',
  },
  {
    id: '13',
    name: 'Vidyarthi Bhavan',
    image:
      'https://images.unsplash.com/photo-1668236543090-82eba5ee5976?auto=format&fit=crop&w=800&q=80',
    distance: '1.4 km',
    rating: 4.7,
    tags: ['Food', 'South Indian', 'Iconic'],
    hours: '6:30 AM - 11:00 AM, 3:00 PM - 7:30 PM',
    phone: '+91 98765 43222',
    storeId: 'VB-1943',
    description:
      'Historic eatery famous for crispy butter dosas and old Bangalore charm.',
    address: 'Gandhi Bazaar, Basavanagudi, Bangalore',
  },
  {
    id: '14',
    name: 'Naturals Salon',
    image:
      'https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=800&q=80',
    distance: '0.8 km',
    rating: 4.6,
    tags: ['Salon', 'Beauty', 'Unisex'],
    hours: '10:00 AM - 8:00 PM',
    phone: '+91 98765 43223',
    storeId: 'NS-7788',
    description:
      'Professional salon chain offering hair, skin, and beauty treatments.',
    address: 'Koramangala 5th Block, Bangalore',
  },
  {
    id: '15',
    name: 'Empire Restaurant',
    image:
      'https://images.unsplash.com/photo-1585937421612-70a008356fbe?auto=format&fit=crop&w=800&q=80',
    distance: '1.0 km',
    rating: 4.5,
    tags: ['Food', 'North Indian', 'Mughlai'],
    hours: '12:00 PM - 11:30 PM',
    phone: '+91 98765 43224',
    storeId: 'EMP-1990',
    description:
      'Popular chain serving North Indian and Mughlai cuisine with generous portions.',
    address: 'Brigade Road, Bangalore',
  },
  {
    id: '16',
    name: 'Cafe Thulp',
    image:
      'https://images.unsplash.com/photo-1554118811-1e0d58224f24?auto=format&fit=crop&w=800&q=80',
    distance: '0.9 km',
    rating: 4.6,
    tags: ['Cafe', 'Coffee', 'Cozy'],
    hours: '9:00 AM - 10:00 PM',
    phone: '+91 98765 43225',
    storeId: 'CT-6677',
    description:
      'Charming neighborhood cafe with excellent coffee and homemade desserts.',
    address: 'Indiranagar 100 Feet Road, Bangalore',
  },
  {
    id: '17',
    name: 'Looks Salon',
    image:
      'https://images.unsplash.com/photo-1562322140-8baeececf3df?auto=format&fit=crop&w=800&q=80',
    distance: '1.2 km',
    rating: 4.5,
    tags: ['Salon', 'Unisex', 'Styling'],
    hours: '10:00 AM - 9:00 PM',
    phone: '+91 98765 43226',
    storeId: 'LS-4455',
    description:
      'Trendy unisex salon with expert stylists and modern treatments.',
    address: 'Jayanagar 4th Block, Bangalore',
  },
  {
    id: '18',
    name: 'Polar Bear',
    image:
      'https://images.unsplash.com/photo-1488900128323-21503983a07e?auto=format&fit=crop&w=800&q=80',
    distance: '1.5 km',
    rating: 4.4,
    tags: ['Dessert', 'Ice Cream', 'Classic'],
    hours: '11:00 AM - 10:30 PM',
    phone: '+91 98765 43227',
    storeId: 'PB-1950',
    description:
      'Vintage ice cream parlor serving classic flavors and sundaes since 1950.',
    address: 'Residency Road, Bangalore',
  },
  {
    id: '19',
    name: 'Cult.fit',
    image:
      'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=800&q=80',
    distance: '0.6 km',
    rating: 4.7,
    tags: ['Fitness', 'Gym', 'Wellness'],
    hours: '5:30 AM - 11:00 PM',
    phone: '+91 98765 43228',
    storeId: 'CF-9988',
    description:
      'Modern fitness center with group classes, personal training, and wellness programs.',
    address: 'Koramangala 6th Block, Bangalore',
  },
  {
    id: '20',
    name: 'Geetanjali Salon',
    image:
      'https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?auto=format&fit=crop&w=800&q=80',
    distance: '1.1 km',
    rating: 4.6,
    tags: ['Salon', 'Spa', 'Luxury'],
    hours: '10:00 AM - 8:00 PM',
    phone: '+91 98765 43229',
    storeId: 'GS-3322',
    description:
      'Premium salon and spa offering luxury beauty treatments and relaxation services.',
    address: 'MG Road, Bangalore',
  },
]

export const MOCK_PLANS: Plan[] = [
  {
    id: 'plan-1',
    title: 'Coffee Hangout ☕',
    storeId: '7',
    storeName: 'Third Wave Coffee',
    storeImage:
      'https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?auto=format&fit=crop&w=800&q=80',
    dateTime: new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString(), // 2 hours from now
    status: 'voting',
    suggestionsRemaining: 2,
    createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    members: [
      { id: 'u1', name: 'Aryan', status: 'confirmed', isHost: true },
      { id: 'u2', name: 'Rahul', status: 'confirmed', isHost: false },
      { id: 'u3', name: 'Meera', status: 'maybe', isHost: false },
      { id: 'u4', name: 'Karthik', status: 'pending', isHost: false },
    ],
    suggestions: [
      {
        id: 's1',
        authorName: 'Rahul',
        type: 'time',
        value: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
        votesUp: ['u2', 'u3'],
        votesDown: ['u1'],
      },
    ],
  },
  {
    id: 'plan-2',
    title: 'Lunch Plan 🍔',
    storeId: '10',
    storeName: 'Truffles',
    storeImage:
      'https://images.unsplash.com/photo-1550547660-d9450f859349?auto=format&fit=crop&w=800&q=80',
    dateTime: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(), // Tomorrow
    status: 'locked',
    suggestionsRemaining: 0,
    createdAt: new Date(Date.now() - 48 * 60 * 60 * 1000).toISOString(),
    groupPerk: 'Free fries on arrival 🍟',
    members: [
      { id: 'u1', name: 'Aryan', status: 'confirmed', isHost: true },
      { id: 'u2', name: 'Rahul', status: 'confirmed', isHost: false },
      { id: 'u3', name: 'Meera', status: 'confirmed', isHost: false },
    ],
    suggestions: [],
  },
  {
    id: 'plan-3',
    title: 'Morning Chai ☕',
    storeId: '1',
    storeName: 'Chai Point',
    storeImage:
      'https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=800&q=80',
    dateTime: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(), // Yesterday
    status: 'completed',
    suggestionsRemaining: 3,
    createdAt: new Date(Date.now() - 72 * 60 * 60 * 1000).toISOString(),
    members: [
      { id: 'u1', name: 'Aryan', status: 'confirmed', isHost: true },
      { id: 'u2', name: 'Rahul', status: 'confirmed', isHost: false },
      { id: 'u3', name: 'Meera', status: 'confirmed', isHost: false },
    ],
    suggestions: [],
  },
]

export const PRODUCTS: Record<string, Product[]> = {
  '1': [
    {
      id: 'p1',
      name: 'Masala Chai',
      price: 50,
      category: 'Chai',
      image:
        'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?auto=format&fit=crop&w=400&q=80',
      description:
        'Traditional Indian spiced tea with ginger, cardamom, and aromatic spices',
    },
    {
      id: 'p2',
      name: 'Filter Coffee',
      price: 60,
      category: 'Coffee',
      image:
        'https://images.unsplash.com/photo-1534778101976-62847782c213?auto=format&fit=crop&w=400&q=80',
      description: 'Strong South Indian filter coffee brewed with chicory',
    },
    {
      id: 'p3',
      name: 'Samosa',
      price: 40,
      category: 'Snacks',
      image:
        'https://images.unsplash.com/photo-1530610476181-d83430b64dcd?auto=format&fit=crop&w=400&q=80',
      description: 'Crispy fried pastry filled with spiced potatoes and peas',
    },
    {
      id: 'p4',
      name: 'Vada Pav',
      price: 35,
      category: 'Snacks',
      image:
        'https://images.unsplash.com/photo-1607958996333-41aef7caefaa?auto=format&fit=crop&w=400&q=80',
      description:
        'Mumbai street food - spiced potato fritter in soft bun with chutneys',
    },
  ],
  '2': [
    {
      id: 'p5',
      name: 'Paneer Tikka Bowl',
      price: 180,
      category: 'Bowls',
      image:
        'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=400&q=80',
      description:
        'Grilled cottage cheese with aromatic rice, fresh vegetables, and mint chutney',
    },
    {
      id: 'p6',
      name: 'Chicken Biryani Bowl',
      price: 220,
      category: 'Bowls',
      image:
        'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=400&q=80',
      description:
        'Fragrant basmati rice layered with tender chicken, saffron, and whole spices',
    },
    {
      id: 'p9',
      name: 'Veggie Noodle Bowl',
      price: 160,
      category: 'Bowls',
      image:
        'https://images.unsplash.com/photo-1512058564366-18510be2db19?auto=format&fit=crop&w=400&q=80',
      description:
        'Asian-style hakka noodles tossed with colorful vegetables and soy sauce',
    },
    {
      id: 'p10',
      name: 'Mango Lassi',
      price: 80,
      category: 'Drinks',
      image:
        'https://images.unsplash.com/photo-1610970881699-44a5587cabec?auto=format&fit=crop&w=400&q=80',
      description:
        'Refreshing yogurt drink blended with sweet Alphonso mango pulp',
    },
  ],
  '3': [
    {
      id: 'p7',
      name: 'The White Tiger',
      price: 350,
      category: 'Fiction',
      image:
        'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?auto=format&fit=crop&w=400&q=80',
      description:
        'Booker Prize-winning novel by Aravind Adiga about modern India',
    },
    {
      id: 'p8',
      name: 'Atomic Habits',
      price: 450,
      category: 'Self-Help',
      image:
        'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?auto=format&fit=crop&w=400&q=80',
      description:
        'Practical guide to building good habits and breaking bad ones by James Clear',
    },
    {
      id: 'p11',
      name: 'The God of Small Things',
      price: 380,
      category: 'Fiction',
      image:
        'https://images.unsplash.com/photo-1544947950-fa07a98d237f?auto=format&fit=crop&w=400&q=80',
      description:
        'Booker Prize winner by Arundhati Roy - a family saga set in Kerala',
    },
    {
      id: 'p12',
      name: 'Shantaram',
      price: 420,
      category: 'Fiction',
      image:
        'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?auto=format&fit=crop&w=400&q=80',
      description:
        'Epic adventure novel by Gregory David Roberts set in Mumbai underworld',
    },
  ],
  '4': [
    {
      id: 'p13',
      name: 'Toit Lager',
      price: 180,
      category: 'Beer',
      image:
        'https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&w=400&q=80',
      description:
        'Signature craft lager - light, crisp, and refreshing house brew',
    },
    {
      id: 'p14',
      name: 'Basmati Blonde',
      price: 200,
      category: 'Beer',
      image:
        'https://images.unsplash.com/photo-1608270586620-248524c67de9?auto=format&fit=crop&w=400&q=80',
      description:
        'Light wheat beer with subtle citrus notes and smooth finish',
    },
    {
      id: 'p15',
      name: 'Butter Chicken Pizza',
      price: 320,
      category: 'Food',
      image:
        'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&w=400&q=80',
      description:
        'Indo-Italian fusion - creamy butter chicken sauce on thin crust pizza',
    },
    {
      id: 'p16',
      name: 'Nachos Supreme',
      price: 240,
      category: 'Food',
      image:
        'https://images.unsplash.com/photo-1513456852971-30c0b8199d4d?auto=format&fit=crop&w=400&q=80',
      description:
        'Crispy tortilla chips loaded with cheese, jalapeños, salsa, and sour cream',
    },
  ],
  '5': [
    {
      id: 'p17',
      name: 'Margherita Pizza',
      price: 280,
      category: 'Pizza',
      image:
        'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?auto=format&fit=crop&w=400&q=80',
      description:
        'Classic Italian - fresh mozzarella, tomato sauce, and basil on thin crust',
    },
    {
      id: 'p18',
      name: 'Paneer Tikka Pizza',
      price: 340,
      category: 'Pizza',
      image:
        'https://images.unsplash.com/photo-1628840042765-356cda07504e?auto=format&fit=crop&w=400&q=80',
      description:
        'Indian fusion pizza with tandoori paneer, bell peppers, and mint chutney',
    },
    {
      id: 'p19',
      name: 'Veggie Supreme',
      price: 320,
      category: 'Pizza',
      image:
        'https://images.unsplash.com/photo-1571997478779-2adcbbe9ab2f?auto=format&fit=crop&w=400&q=80',
      description:
        'Loaded with bell peppers, mushrooms, olives, onions, and fresh tomatoes',
    },
    {
      id: 'p20',
      name: 'Garlic Bread',
      price: 120,
      category: 'Sides',
      image:
        'https://cdn.magicpatterns.com/uploads/8yuAzrFa7WRDW1LWvwZQz1/pasted-image.jpg',
      description: 'Fresh-baked bread brushed with garlic butter and herbs',
    },
  ],
  // MTR - South Indian Restaurant
  '6': [
    {
      id: 'p21',
      name: 'Masala Dosa',
      price: 100,
      category: 'Breakfast',
      image:
        'https://images.unsplash.com/photo-1668236543090-82eba5ee5976?auto=format&fit=crop&w=400&q=80',
      description:
        'Crispy rice crepe filled with spiced potato masala, served with sambar and chutneys',
    },
    {
      id: 'p22',
      name: 'Idli Vada',
      price: 80,
      category: 'Breakfast',
      image:
        'https://images.unsplash.com/photo-1589301760014-d929f3979dbc?auto=format&fit=crop&w=400&q=80',
      description:
        'Steamed rice cakes and crispy lentil fritters with sambar and coconut chutney',
    },
    {
      id: 'p23',
      name: 'Bisi Bele Bath',
      price: 120,
      category: 'Rice',
      image:
        'https://images.unsplash.com/photo-1596797038530-2c107229654b?auto=format&fit=crop&w=400&q=80',
      description:
        'Traditional Karnataka rice dish with lentils, vegetables, and aromatic spices',
    },
    {
      id: 'p24',
      name: 'Filter Coffee',
      price: 40,
      category: 'Beverages',
      image:
        'https://images.unsplash.com/photo-1534778101976-62847782c213?auto=format&fit=crop&w=400&q=80',
      description: 'Authentic South Indian filter coffee with perfect froth',
    },
  ],
  // Third Wave Coffee - Specialty Cafe
  '7': [
    {
      id: 'p25',
      name: 'Flat White',
      price: 150,
      category: 'Coffee',
      image:
        'https://images.unsplash.com/photo-1572442388796-11668a67e53d?auto=format&fit=crop&w=400&q=80',
      description: 'Velvety microfoam espresso with single-origin beans',
    },
    {
      id: 'p26',
      name: 'Cold Brew',
      price: 180,
      category: 'Coffee',
      image:
        'https://images.unsplash.com/photo-1517487881594-2787fef5ebf7?auto=format&fit=crop&w=400&q=80',
      description: 'Smooth, low-acid cold brew steeped for 18 hours',
    },
    {
      id: 'p27',
      name: 'Croissant',
      price: 120,
      category: 'Pastries',
      image:
        'https://images.unsplash.com/photo-1555507036-ab1f4038808a?auto=format&fit=crop&w=400&q=80',
      description: 'Buttery, flaky French croissant baked fresh daily',
    },
    {
      id: 'p28',
      name: 'Avocado Toast',
      price: 220,
      category: 'Food',
      image:
        'https://images.unsplash.com/photo-1588137378633-dea1336ce1e2?auto=format&fit=crop&w=400&q=80',
      description: 'Smashed avocado on sourdough with cherry tomatoes and feta',
    },
  ],
  // Corner House - Ice Cream Parlor
  '8': [
    {
      id: 'p29',
      name: 'Death by Chocolate',
      price: 180,
      category: 'Sundaes',
      image:
        'https://images.unsplash.com/photo-1563805042-7684c019e1cb?auto=format&fit=crop&w=400&q=80',
      description:
        'Legendary sundae with chocolate ice cream, hot fudge, and brownie chunks',
    },
    {
      id: 'p30',
      name: 'Butterscotch Scoop',
      price: 80,
      category: 'Ice Cream',
      image:
        'https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?auto=format&fit=crop&w=400&q=80',
      description: 'Rich butterscotch ice cream with crunchy caramel bits',
    },
    {
      id: 'p31',
      name: 'Fresh Fruit Sundae',
      price: 150,
      category: 'Sundaes',
      image:
        'https://images.unsplash.com/photo-1488900128323-21503983a07e?auto=format&fit=crop&w=400&q=80',
      description:
        'Vanilla ice cream topped with fresh seasonal fruits and whipped cream',
    },
    {
      id: 'p32',
      name: 'Chocolate Shake',
      price: 120,
      category: 'Shakes',
      image:
        'https://images.unsplash.com/photo-1572490122747-3968b75cc699?auto=format&fit=crop&w=400&q=80',
      description: 'Thick chocolate milkshake blended with premium ice cream',
    },
  ],
  // Veena Stores - Traditional South Indian
  '9': [
    {
      id: 'p33',
      name: 'Masala Dosa',
      price: 100,
      category: 'Dosas',
      image:
        'https://images.unsplash.com/photo-1668236543090-82eba5ee5976?auto=format&fit=crop&w=400&q=80',
      description: 'Crispy golden dosa with perfectly spiced potato filling',
    },
    {
      id: 'p34',
      name: 'Set Dosa',
      price: 90,
      category: 'Dosas',
      image:
        'https://images.unsplash.com/photo-1630383249896-424e482df921?auto=format&fit=crop&w=400&q=80',
      description: 'Soft, fluffy dosas served in a set of three with chutney',
    },
    {
      id: 'p35',
      name: 'Kesari Bath',
      price: 60,
      category: 'Sweets',
      image:
        'https://images.unsplash.com/photo-1606491956689-2ea866880c84?auto=format&fit=crop&w=400&q=80',
      description: 'Sweet semolina pudding with ghee, saffron, and cashews',
    },
    {
      id: 'p36',
      name: 'Filter Coffee',
      price: 30,
      category: 'Beverages',
      image:
        'https://images.unsplash.com/photo-1534778101976-62847782c213?auto=format&fit=crop&w=400&q=80',
      description:
        'Traditional filter coffee served in steel tumbler and davara',
    },
  ],
  // Truffles - Burger Joint
  '10': [
    {
      id: 'p37',
      name: 'Classic Burger',
      price: 280,
      category: 'Burgers',
      image:
        'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&w=400&q=80',
      description:
        'Massive beef patty with cheese, lettuce, tomato, and special sauce',
    },
    {
      id: 'p38',
      name: 'Chicken Wings',
      price: 320,
      category: 'Appetizers',
      image:
        'https://images.unsplash.com/photo-1527477396000-e27163b481c2?auto=format&fit=crop&w=400&q=80',
      description: 'Crispy fried wings tossed in buffalo or BBQ sauce',
    },
    {
      id: 'p39',
      name: 'Loaded Fries',
      price: 200,
      category: 'Sides',
      image:
        'https://images.unsplash.com/photo-1573080496219-bb080dd4f877?auto=format&fit=crop&w=400&q=80',
      description: 'Crispy fries loaded with cheese, bacon, and jalapeños',
    },
    {
      id: 'p40',
      name: 'Chocolate Shake',
      price: 150,
      category: 'Shakes',
      image:
        'https://images.unsplash.com/photo-1572490122747-3968b75cc699?auto=format&fit=crop&w=400&q=80',
      description: 'Thick, indulgent chocolate milkshake',
    },
  ],
  // Naturals Ice Cream
  '11': [
    {
      id: 'p41',
      name: 'Tender Coconut',
      price: 100,
      category: 'Ice Cream',
      image:
        'https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?auto=format&fit=crop&w=400&q=80',
      description:
        'Fresh tender coconut ice cream made with real coconut water',
    },
    {
      id: 'p42',
      name: 'Mango',
      price: 110,
      category: 'Ice Cream',
      image:
        'https://images.unsplash.com/photo-1488900128323-21503983a07e?auto=format&fit=crop&w=400&q=80',
      description: 'Alphonso mango ice cream with real fruit pulp',
    },
    {
      id: 'p43',
      name: 'Sitaphal (Custard Apple)',
      price: 120,
      category: 'Ice Cream',
      image:
        'https://images.unsplash.com/photo-1563805042-7684c019e1cb?auto=format&fit=crop&w=400&q=80',
      description: 'Seasonal custard apple ice cream with natural sweetness',
    },
    {
      id: 'p44',
      name: 'Strawberry',
      price: 100,
      category: 'Ice Cream',
      image:
        'https://images.unsplash.com/photo-1501443762994-82bd5dace89a?auto=format&fit=crop&w=400&q=80',
      description: 'Fresh strawberry ice cream with real fruit chunks',
    },
  ],
  // Brahmin's Coffee Bar
  '12': [
    {
      id: 'p45',
      name: 'Filter Coffee',
      price: 30,
      category: 'Beverages',
      image:
        'https://images.unsplash.com/photo-1534778101976-62847782c213?auto=format&fit=crop&w=400&q=80',
      description:
        'Strong, authentic filter coffee in traditional steel tumbler',
    },
    {
      id: 'p46',
      name: 'Vada',
      price: 25,
      category: 'Snacks',
      image:
        'https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=400&q=80',
      description: 'Crispy medu vada with coconut chutney',
    },
    {
      id: 'p47',
      name: 'Idli',
      price: 40,
      category: 'Breakfast',
      image:
        'https://images.unsplash.com/photo-1589301760014-d929f3979dbc?auto=format&fit=crop&w=400&q=80',
      description: 'Soft steamed rice cakes served with sambar and chutney',
    },
    {
      id: 'p48',
      name: 'Upma',
      price: 50,
      category: 'Breakfast',
      image:
        'https://images.unsplash.com/photo-1606491956689-2ea866880c84?auto=format&fit=crop&w=400&q=80',
      description: 'Savory semolina porridge with vegetables and spices',
    },
  ],
  // Vidyarthi Bhavan
  '13': [
    {
      id: 'p49',
      name: 'Butter Dosa',
      price: 100,
      category: 'Dosas',
      image:
        'https://images.unsplash.com/photo-1668236543090-82eba5ee5976?auto=format&fit=crop&w=400&q=80',
      description: 'Legendary crispy dosa generously smeared with butter',
    },
    {
      id: 'p50',
      name: 'Masala Dosa',
      price: 90,
      category: 'Dosas',
      image:
        'https://images.unsplash.com/photo-1630383249896-424e482df921?auto=format&fit=crop&w=400&q=80',
      description: 'Classic masala dosa with potato filling',
    },
    {
      id: 'p51',
      name: 'Coffee',
      price: 40,
      category: 'Beverages',
      image:
        'https://images.unsplash.com/photo-1511920170033-f8396924c348?auto=format&fit=crop&w=400&q=80',
      description: 'Traditional filter coffee to accompany your dosa',
    },
    {
      id: 'p52',
      name: 'Vada',
      price: 30,
      category: 'Snacks',
      image:
        'https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=400&q=80',
      description: 'Crispy lentil fritters served with chutney',
    },
  ],
  // Naturals Salon
  '14': [
    {
      id: 'p53',
      name: 'Haircut & Styling',
      price: 500,
      category: 'Hair Services',
      image:
        'https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=400&q=80',
      description: 'Professional haircut with wash and styling',
    },
    {
      id: 'p54',
      name: 'Hair Spa',
      price: 800,
      category: 'Hair Services',
      image:
        'https://images.unsplash.com/photo-1562322140-8baeececf3df?auto=format&fit=crop&w=400&q=80',
      description: 'Deep conditioning hair spa treatment with massage',
    },
    {
      id: 'p55',
      name: 'Facial',
      price: 1200,
      category: 'Skin Care',
      image:
        'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?auto=format&fit=crop&w=400&q=80',
      description: 'Cleansing and rejuvenating facial treatment',
    },
    {
      id: 'p56',
      name: 'Manicure & Pedicure',
      price: 900,
      category: 'Nail Care',
      image:
        'https://images.unsplash.com/photo-1604654894610-df63bc536371?auto=format&fit=crop&w=400&q=80',
      description: 'Complete nail care with polish and massage',
    },
  ],
  // Empire Restaurant
  '15': [
    {
      id: 'p57',
      name: 'Chicken Biryani',
      price: 250,
      category: 'Biryani',
      image:
        'https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?auto=format&fit=crop&w=400&q=80',
      description: 'Aromatic Hyderabadi-style chicken biryani with raita',
    },
    {
      id: 'p58',
      name: 'Butter Chicken',
      price: 280,
      category: 'Main Course',
      image:
        'https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?auto=format&fit=crop&w=400&q=80',
      description: 'Creamy tomato-based curry with tender chicken pieces',
    },
    {
      id: 'p59',
      name: 'Tandoori Roti',
      price: 30,
      category: 'Breads',
      image:
        'https://images.unsplash.com/photo-1628840042765-356cda07504e?auto=format&fit=crop&w=400&q=80',
      description: 'Whole wheat flatbread baked in tandoor',
    },
    {
      id: 'p60',
      name: 'Gulab Jamun',
      price: 80,
      category: 'Desserts',
      image:
        'https://images.unsplash.com/photo-1606491956689-2ea866880c84?auto=format&fit=crop&w=400&q=80',
      description: 'Soft milk dumplings soaked in rose-flavored syrup',
    },
  ],
  // Cafe Thulp
  '16': [
    {
      id: 'p61',
      name: 'Cappuccino',
      price: 140,
      category: 'Coffee',
      image:
        'https://images.unsplash.com/photo-1572442388796-11668a67e53d?auto=format&fit=crop&w=400&q=80',
      description: 'Classic cappuccino with perfect foam art',
    },
    {
      id: 'p62',
      name: 'Chocolate Brownie',
      price: 150,
      category: 'Desserts',
      image:
        'https://images.unsplash.com/photo-1606313564200-e75d5e30476c?auto=format&fit=crop&w=400&q=80',
      description: 'Warm, fudgy brownie with vanilla ice cream',
    },
    {
      id: 'p63',
      name: 'Club Sandwich',
      price: 220,
      category: 'Food',
      image:
        'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?auto=format&fit=crop&w=400&q=80',
      description: 'Triple-decker sandwich with chicken, bacon, and veggies',
    },
    {
      id: 'p64',
      name: 'Iced Latte',
      price: 160,
      category: 'Coffee',
      image:
        'https://images.unsplash.com/photo-1517487881594-2787fef5ebf7?auto=format&fit=crop&w=400&q=80',
      description: 'Chilled espresso with cold milk and ice',
    },
  ],
  // Looks Salon
  '17': [
    {
      id: 'p65',
      name: 'Haircut (Men)',
      price: 400,
      category: 'Hair Services',
      image:
        'https://images.unsplash.com/photo-1622286342621-4bd786c2447f?auto=format&fit=crop&w=400&q=80',
      description: 'Modern haircut with styling for men',
    },
    {
      id: 'p66',
      name: 'Haircut (Women)',
      price: 600,
      category: 'Hair Services',
      image:
        'https://images.unsplash.com/photo-1562322140-8baeececf3df?auto=format&fit=crop&w=400&q=80',
      description: 'Professional haircut with blow-dry for women',
    },
    {
      id: 'p67',
      name: 'Hair Color',
      price: 2500,
      category: 'Hair Services',
      image:
        'https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=400&q=80',
      description: 'Full hair coloring with premium products',
    },
    {
      id: 'p68',
      name: 'Beard Trim & Styling',
      price: 250,
      category: 'Grooming',
      image:
        'https://images.unsplash.com/photo-1621607512214-68297480165e?auto=format&fit=crop&w=400&q=80',
      description: 'Professional beard trimming and shaping',
    },
  ],
  // Polar Bear
  '18': [
    {
      id: 'p69',
      name: 'Vanilla Cone',
      price: 60,
      category: 'Ice Cream',
      image:
        'https://images.unsplash.com/photo-1488900128323-21503983a07e?auto=format&fit=crop&w=400&q=80',
      description: 'Classic vanilla ice cream in crispy cone',
    },
    {
      id: 'p70',
      name: 'Chocolate Sundae',
      price: 120,
      category: 'Sundaes',
      image:
        'https://images.unsplash.com/photo-1563805042-7684c019e1cb?auto=format&fit=crop&w=400&q=80',
      description: 'Chocolate ice cream with hot fudge and nuts',
    },
    {
      id: 'p71',
      name: 'Strawberry Scoop',
      price: 80,
      category: 'Ice Cream',
      image:
        'https://images.unsplash.com/photo-1501443762994-82bd5dace89a?auto=format&fit=crop&w=400&q=80',
      description: 'Fresh strawberry ice cream',
    },
    {
      id: 'p72',
      name: 'Banana Split',
      price: 150,
      category: 'Sundaes',
      image:
        'https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?auto=format&fit=crop&w=400&q=80',
      description: 'Three scoops with banana, toppings, and whipped cream',
    },
  ],
  // Cult.fit
  '19': [
    {
      id: 'p73',
      name: 'Monthly Membership',
      price: 2500,
      category: 'Membership',
      image:
        'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=400&q=80',
      description: 'Unlimited access to gym and group classes for one month',
    },
    {
      id: 'p74',
      name: 'Personal Training (5 Sessions)',
      price: 5000,
      category: 'Training',
      image:
        'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=400&q=80',
      description: 'Five one-on-one personal training sessions',
    },
    {
      id: 'p75',
      name: 'Yoga Class',
      price: 500,
      category: 'Classes',
      image:
        'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&w=400&q=80',
      description: 'Single yoga class session',
    },
    {
      id: 'p76',
      name: 'Zumba Class',
      price: 500,
      category: 'Classes',
      image:
        'https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&w=400&q=80',
      description: 'High-energy Zumba dance fitness class',
    },
  ],
  // Geetanjali Salon
  '20': [
    {
      id: 'p77',
      name: 'Luxury Facial',
      price: 2000,
      category: 'Skin Care',
      image:
        'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?auto=format&fit=crop&w=400&q=80',
      description: 'Premium facial treatment with luxury products',
    },
    {
      id: 'p78',
      name: 'Hair Spa & Treatment',
      price: 1500,
      category: 'Hair Services',
      image:
        'https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=400&q=80',
      description: 'Intensive hair spa with keratin treatment',
    },
    {
      id: 'p79',
      name: 'Body Massage',
      price: 2500,
      category: 'Spa',
      image:
        'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?auto=format&fit=crop&w=400&q=80',
      description: 'Full body relaxation massage with aromatherapy',
    },
    {
      id: 'p80',
      name: 'Bridal Makeup',
      price: 8000,
      category: 'Makeup',
      image:
        'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?auto=format&fit=crop&w=400&q=80',
      description: 'Complete bridal makeup with hairstyling',
    },
  ],
}

export const MOCK_ORDERS: Order[] = [
  {
    id: 'ord-123',
    date: '2023-10-25',
    status: 'completed',
    total: 160,
    storeId: '1',
    storeName: 'Chai Point',
    storeImage: STORES[0].image,
    items: [
      {
        id: 'p1',
        name: 'Masala Chai',
        price: 50,
        category: 'Chai',
        image: '',
        description: '',
        quantity: 2,
      },
      {
        id: 'p3',
        name: 'Samosa',
        price: 40,
        category: 'Snacks',
        image: '',
        description: '',
        quantity: 2,
      },
    ],
  },
  {
    id: 'ord-124',
    date: 'Today, 10:30 AM',
    status: 'preparing',
    total: 120,
    storeId: '1',
    storeName: 'Chai Point',
    storeImage: STORES[0].image,
    items: [
      {
        id: 'p2',
        name: 'Filter Coffee',
        price: 60,
        category: 'Coffee',
        image: '',
        description: '',
        quantity: 2,
      },
    ],
    isRecent: true,
  },
]

export const MOCK_GIFTS: Gift[] = [
  {
    id: 'g-1',
    itemId: 'p7',
    itemName: 'The White Tiger',
    itemImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?auto=format&fit=crop&w=400&q=80',
    itemPrice: 350,
    storeId: '3',
    storeName: 'Blossoms Book House',
    storeImage: STORES[2].image,
    sender: 'Priya',
    recipient: 'You',
    message: 'Happy Birthday! Enjoy this classic read.',
    status: 'pending',
    date: '2023-10-20',
    code: 'GIFT-8821',
  },
  {
    id: 'g-2',
    itemId: 'p1',
    itemName: 'Masala Chai',
    itemImage:
      'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?auto=format&fit=crop&w=400&q=80',
    itemPrice: 50,
    storeId: '1',
    storeName: 'Chai Point',
    storeImage: STORES[0].image,
    sender: 'You',
    recipient: 'Rahul',
    message: 'Thanks for helping me move!',
    status: 'redeemed',
    date: '2023-09-15',
    code: 'GIFT-9912',
  },
  {
    id: 'g-3',
    itemId: 'p5',
    itemName: 'Paneer Tikka Bowl',
    itemImage:
      'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=400&q=80',
    itemPrice: 180,
    storeId: '2',
    storeName: 'The Bowl Company',
    storeImage: STORES[1].image,
    sender: 'Sneha',
    recipient: 'You',
    message: 'Congrats on your promotion! 🎉',
    status: 'pending',
    date: '2023-10-22',
    code: 'GIFT-3344',
  },
]

export const MOCK_USER: UserProfile = {
  id: 'u-123456',
  name: 'Arjun',
  email: 'arjun@example.com',
  avatar:
    'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=200&q=80',
  points: 1250,
  stamps: {
    '1': 7,
    '2': 3,
  },
  birthday: '05-14',
}

export const MOCK_DATES: SpecialDate[] = [
  {
    id: 'd1',
    name: "Mom's Birthday",
    date: '05-14',
    type: 'birthday',
    notes: 'Loves flowers',
  },
  { id: 'd2', name: 'Anniversary', date: '09-22', type: 'anniversary' },
]
